<div class="menu-content">
  <div class="menu">
    <div class="mobile-menu-wrapper">
      <a class="logo-container cursor-pointer" routerLink="/home">
        <img src="assets/images/logo-wide.svg" alt="Logo" class="logo" />
      </a>

      <div class="mobile-menu-actions">
        <div class="cart-button-container">
          <button
            class="inwi-icon-button-large-secondary cart-button"
            routerLink="cart">
            <i class="fa-regular fa-cart-shopping"></i>
          </button>
          @if (cartService.getItemsCount() > 0) {
            <div class="cart-item-amount">
              {{ cartService.getItemsCount() }}
            </div>
          }
        </div>

        <button
          class="mobile-menu-trigger inwi-icon-button-medium-secondary"
          (click)="showMobileMenu = !showMobileMenu">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-bars"></i>
            </div>
          </div>
        </button>
      </div>
    </div>
    <div class="nav-container">
      <div>
        <button
          class="nav-link"
          (click)="trainingCategoriesMenu.toggle($event)">
          <div class="nav-text">Fortbildungen</div>
          <div class="nav-expander">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </button>
        <p-menu
          #trainingCategoriesMenu
          [model]="trainingCategoriesMenuItems"
          [popup]="true">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              class="flex align-items-center p-menu-item-link"
              [routerLink]="item.link">
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
      </div>

      <div>
        <button class="nav-link" (click)="serviceMenu.toggle($event)">
          <div class="nav-text">Service</div>
          <div class="nav-expander">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </button>
        <p-menu #serviceMenu [model]="serviceMenuItems" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              class="flex align-items-center p-menu-item-link"
              [routerLink]="item.link">
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
      </div>

      <div>
        <button class="nav-link" (click)="aboutMenu.toggle($event)">
          <div class="nav-text">Über uns</div>
          <div class="nav-expander">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </button>
        <p-menu #aboutMenu [model]="aboutMenuItems" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              class="flex align-items-center p-menu-item-link"
              [routerLink]="item.link">
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
      </div>

      <div class="nav-link" (click)="route('coupons')">
        <div class="nav-text">Gutschein</div>
        <div class="nav-expander">
          <i class="fa-regular fa-ticket"></i>
        </div>
      </div>
    </div>

    <div class="flex-r gap-16">
      <div id="cart-button-container" class="cart-button-container">
        <button
          class="inwi-icon-button-large-secondary cart-button"
          routerLink="cart">
          <i class="fa-regular fa-cart-shopping"></i>
        </button>
        @if (cartService.getItemsCount() > 0) {
          <div class="cart-item-amount">{{ cartService.getItemsCount() }}</div>
        }
      </div>
      @if (
        userService.getUser() === undefined || userService.getUser() === null
      ) {
        <div class="login-container">
          <button class="inwi-text-button-large-secondary" (click)="onLogin()">
            <div class="button-content">
              <div class="button-text">Anmelden</div>
            </div>
          </button>
          <button
            class="inwi-text-button-large-primary"
            (click)="route('register')">
            <div class="button-content">
              <div class="button-text">Registrieren</div>
            </div>
          </button>
        </div>
      } @else {
        <div class="user-menu-wrapper">
          <button
            class="user-container inwi-text-button-large-secondary"
            (click)="userMenu.toggle($event)">
            <app-avatar
              class="avatar"
              size="x-small"
              [user]="userService.currentUser$.value"></app-avatar>

            <div class="user-name">
              {{
                userService.currentUser$.value?.firstname +
                  ' ' +
                  userService.currentUser$.value?.lastname
              }}
            </div>
            <div class="user-expander">
              <i class="fa-solid fa-chevron-down"></i>
            </div>
          </button>

          <p-menu #userMenu [model]="userMenuItems" [popup]="true">
            <ng-template pTemplate="item" let-item>
              <a
                pRipple
                class="flex align-items-center p-menu-item-link icon-24"
                [routerLink]="item.link"
                [queryParams]="item.queryParams">
                <i [class]="item.icon"></i>
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </ng-template>
          </p-menu>
        </div>
      }
    </div>
  </div>
</div>

<!-- Mobile Menu -->
<div class="mobile-menu-content" [class.open]="showMobileMenu">
  <div class="header">
    <a
      class="logo-container cursor-pointer"
      routerLink="/home"
      (click)="showMobileMenu = !showMobileMenu">
      <img src="assets/images/logo-wide.svg" alt="Logo" class="logo" />
    </a>
    <button
      class="inwi-icon-button-medium-secondary"
      (click)="showMobileMenu = !showMobileMenu">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-bars"></i>
        </div>
      </div>
    </button>
  </div>
  <div class="menu-items">
    @if (
      userService.getUser() === undefined || userService.getUser() === null
    ) {
      <div id="mobile-login-buttons" class="flex-r gap-12">
        <button
          class="inwi-text-button-medium-secondary"
          (click)="showMobileMenu = !showMobileMenu; route('login')">
          <div class="button-content">
            <div class="button-text">Anmelden</div>
          </div>
        </button>
        <button
          class="inwi-text-button-medium-primary"
          (click)="showMobileMenu = !showMobileMenu; route('register')">
          <div class="button-content">
            <div class="button-text">Registrieren</div>
          </div>
        </button>
      </div>
    } @else {
      <div id="mobile-user-menu" class="mobile-nav-item">
        <button
          class="mobile-nav-item-parent user-container inwi-text-button-medium-secondary"
          (click)="toggleSection('user')">
          <app-avatar
            class="avatar"
            size="x-small"
            [user]="userService.currentUser$.value"></app-avatar>

          <div class="user-name">
            {{
              userService.currentUser$.value?.firstname +
                ' ' +
                userService.currentUser$.value?.lastname
            }}
          </div>
          <div class="user-expander">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </button>
        @if (sections.user) {
          @for (menuItem of userMenuItems; track $index) {
            <a
              class="mobile-nav-item-child mobile-nav-item-user-menu"
              (click)="menuItem.command()"
              [routerLink]="menuItem.link"
              routerLinkActive="active"
              [queryParams]="menuItem.queryParams">
              <i [class]="menuItem.icon"></i>
              {{ menuItem.label }}
            </a>
          }
        }
      </div>
    }
    <div class="mobile-nav-items">
      <div class="mobile-nav-item">
        <div
          class="mobile-nav-item-parent"
          (click)="toggleSection('trainingCategories')">
          Fortbildungen
          <i
            class="fa-solid"
            [class.fa-chevron-down]="!sections.trainingCategories"
            [class.fa-chevron-up]="sections.trainingCategories"></i>
        </div>
        @if (sections.trainingCategories) {
          @for (menuItem of trainingCategoriesMenuItems; track $index) {
            <a
              class="mobile-nav-item-child"
              (click)="menuItem.command()"
              [routerLink]="menuItem.link"
              routerLinkActive="active">
              {{ menuItem.label }}
            </a>
          }
        }
      </div>
      <div class="mobile-nav-item">
        <div class="mobile-nav-item-parent" (click)="toggleSection('service')">
          Service
          <i
            class="fa-solid"
            [class.fa-chevron-down]="!sections.service"
            [class.fa-chevron-up]="sections.service"></i>
        </div>
        @if (sections.service) {
          @for (menuItem of serviceMenuItems; track $index) {
            <a
              class="mobile-nav-item-child"
              (click)="menuItem.command()"
              [routerLink]="menuItem.link"
              routerLinkActive="active">
              {{ menuItem.label }}
            </a>
          }
        }
      </div>
      <div class="mobile-nav-item">
        <div class="mobile-nav-item-parent" (click)="toggleSection('about')">
          Über uns
          <i
            class="fa-solid"
            [class.fa-chevron-down]="!sections.about"
            [class.fa-chevron-up]="sections.about"></i>
        </div>
        @if (sections.about) {
          @for (menuItem of aboutMenuItems; track $index) {
            <a
              class="mobile-nav-item-child"
              (click)="menuItem.command()"
              [routerLink]="menuItem.link"
              routerLinkActive="active">
              {{ menuItem.label }}
            </a>
          }
        }
      </div>
      <div class="mobile-nav-item">
        <div
          (click)="showMobileMenu = !showMobileMenu"
          class="mobile-nav-item-parent"
          routerLink="coupons"
          routerLinkActive="active">
          Gutschein
          <i class="fa-regular fa-ticket"></i>
        </div>
      </div>
    </div>
  </div>
</div>
